import { render, staticRenderFns } from "./Aktuelles.vue?vue&type=template&id=964cd7be&scoped=true&"
import script from "./Aktuelles.vue?vue&type=script&lang=js&"
export * from "./Aktuelles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964cd7be",
  null
  
)

export default component.exports